import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '@core/auth/user/user.service';


export const AuthGuard: CanActivateFn = (route, state) => {

  const session = inject(UserService).loginData();

  // Valid session: allow navigation
  return session ? inject(Router).createUrlTree(['/products']) : true;
};
